import moment from 'moment';
import 'moment/locale/fr';
moment().locale('fr');
export default moment;


// WEBPACK FOOTER //
// ./src/components/shared/utils/moment_fr.js